/**
 * Cookie 鍵名常數
 * 集中管理所有應用程式使用的 Cookie 鍵名
 */

export const COOKIE_KEYS = {
  // 身份驗證相關
  AUTH_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER_ID: "user_id",

  // 使用者偏好相關
  LANGUAGE: "preferred_language",
  THEME: "preferred_theme",

  // 功能相關
  LAST_VISIT: "last_visit",
  SESSION_ID: "session_id",

  // 同意相關
  COOKIE_CONSENT: "cookie_consent",
  PRIVACY_CONSENT: "privacy_consent",
};
